import { render, staticRenderFns } from "./APPurchaseHistory.vue?vue&type=template&id=b3da4384&scoped=true&"
import script from "./APPurchaseHistory.vue?vue&type=script&lang=js&"
export * from "./APPurchaseHistory.vue?vue&type=script&lang=js&"
import style0 from "./APPurchaseHistory.vue?vue&type=style&index=0&id=b3da4384&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3da4384",
  null
  
)

component.options.__file = "APPurchaseHistory.vue"
export default component.exports